/**
 * @generated SignedSource<<5566a27c8adeee401e284f75db585fec>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TransactionTypeEnum = "ACCEPT_OFFER" | "ACCEPT_SWAP" | "APPROVE_COLLECTION" | "ASSETS_RECEIVED" | "ASSETS_SENT" | "BRIDGE_DEPOSIT" | "BRIDGE_WITHDRAW" | "BULK_ACCEPT_OFFER" | "BULK_OFFER_ACCEPTED" | "BULK_PURCHASE" | "BULK_RECEIVED" | "BULK_SALE" | "BULK_SENT" | "BUY_NOW" | "CANCEL_ALL_ORDERS" | "CANCEL_ASK" | "CANCEL_BID" | "CANCEL_COLLECTION_OFFFER" | "CANCEL_ORDERS" | "CANCEL_SWAP" | "CONFIGURE_DROP" | "CREATE_SEADROP_CONTRACT" | "ERC20_APPROVE" | "ERC20_RECEIVED" | "ERC20_SENT" | "ERC20_SWAP_DEPOSIT" | "ERC20_SWAP_WITHDRAW" | "MINT" | "MINT_ALLOWLIST" | "NATIVE_RECEIVED" | "NATIVE_SENT" | "NFT_RECEIVED" | "NFT_SENT" | "OFFER_ACCEPTED" | "OPENSEA_PRO_TRADE" | "REDEEM" | "SALE" | "SWAP_COMPLETE" | "UNKNOWN" | "UNWRAP" | "WRAP" | "%future added value";
export type TransactionConfirmationModalQuery$variables = {
  chain: | "ETHEREUM" | "MATIC" | "KLAYTN" | "BSC" | "SOLANA" | "ARBITRUM" | "ARBITRUM_NOVA" | "AVALANCHE" | "OPTIMISM" | "OPTIMISM_SEPOLIA" | "AMOY" | "BAOBAB" | "BSC_TESTNET" | "SOLDEV" | "ARBITRUM_SEPOLIA" | "AVALANCHE_FUJI" | "SEPOLIA" | "BASE" | "BASE_SEPOLIA" | "ZORA" | "ZORA_SEPOLIA" | "ZORA_TESTNET"  | "FLOW" | "FLOW_TESTNET" | "BLAST_SEPOLIA" | "BLAST" | "GUNZILLA" | "GUNZILLA_TESTNET" | "SEI" | "SEI_TESTNET" | "B3_SEPOLIA" | "B3" |  "APE_CHAIN" | "APE_CURTIS" | "SONEIUM_MINATO" | "SONEIUM" | "RONIN" | "BERA_CHAIN" | "SHAPE" | "UNICHAIN" | "MONAD_TESTNET" | "SAIGON_TESTNET" | "ABSTRACT_TESTNET" | "%future added value";
  data: string;
  from: string;
  nativeCurrencySymbol: string;
  to: string;
  value: string;
};
export type TransactionConfirmationModalQuery$data = {
  readonly transactionMetadata: {
    readonly type: TransactionTypeEnum;
    readonly " $fragmentSpreads": FragmentRefs<"TransactionDetails_metadata" | "useTransactionNativeCurrencyTotal_metadata">;
  } | null | undefined;
  readonly wallet: {
    readonly fundsOf: {
      readonly quantity: string;
    };
  };
};
export type TransactionConfirmationModalQuery = {
  response: TransactionConfirmationModalQuery$data;
  variables: TransactionConfirmationModalQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "chain"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "data"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "from"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "nativeCurrencySymbol"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "to"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "value"
},
v6 = {
  "kind": "Variable",
  "name": "chain",
  "variableName": "chain"
},
v7 = [
  (v6/*: any*/),
  {
    "kind": "Variable",
    "name": "fromAddress",
    "variableName": "from"
  },
  {
    "kind": "Variable",
    "name": "inputData",
    "variableName": "data"
  },
  {
    "kind": "Variable",
    "name": "toAddress",
    "variableName": "to"
  },
  {
    "kind": "Variable",
    "name": "value",
    "variableName": "value"
  }
],
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v9 = [
  {
    "kind": "Variable",
    "name": "address",
    "variableName": "from"
  }
],
v10 = [
  (v6/*: any*/),
  {
    "kind": "Variable",
    "name": "symbol",
    "variableName": "nativeCurrencySymbol"
  }
],
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "quantity",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "usdSpotPrice",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "symbol",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "decimals",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayImageUrl",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "tokenStandard",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "TransactionConfirmationModalQuery",
    "selections": [
      {
        "alias": null,
        "args": (v7/*: any*/),
        "concreteType": "TransactionMetadataType",
        "kind": "LinkedField",
        "name": "transactionMetadata",
        "plural": false,
        "selections": [
          (v8/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "TransactionDetails_metadata"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "useTransactionNativeCurrencyTotal_metadata"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v9/*: any*/),
        "concreteType": "WalletType",
        "kind": "LinkedField",
        "name": "wallet",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v10/*: any*/),
            "concreteType": "WalletFundsType",
            "kind": "LinkedField",
            "name": "fundsOf",
            "plural": false,
            "selections": [
              (v11/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v4/*: any*/),
      (v2/*: any*/),
      (v5/*: any*/),
      (v0/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "TransactionConfirmationModalQuery",
    "selections": [
      {
        "alias": null,
        "args": (v7/*: any*/),
        "concreteType": "TransactionMetadataType",
        "kind": "LinkedField",
        "name": "transactionMetadata",
        "plural": false,
        "selections": [
          (v8/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "AssetQuantityType",
            "kind": "LinkedField",
            "name": "sentAssetQuantities",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "AssetType",
                "kind": "LinkedField",
                "name": "asset",
                "plural": false,
                "selections": [
                  (v12/*: any*/),
                  (v13/*: any*/),
                  (v14/*: any*/),
                  (v15/*: any*/),
                  (v16/*: any*/),
                  (v17/*: any*/),
                  (v18/*: any*/)
                ],
                "storageKey": null
              },
              (v11/*: any*/),
              (v15/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AssetQuantityType",
            "kind": "LinkedField",
            "name": "receivedAssetQuantities",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "AssetType",
                "kind": "LinkedField",
                "name": "asset",
                "plural": false,
                "selections": [
                  (v16/*: any*/),
                  (v17/*: any*/),
                  (v15/*: any*/),
                  (v12/*: any*/),
                  (v13/*: any*/),
                  (v14/*: any*/),
                  (v18/*: any*/)
                ],
                "storageKey": null
              },
              (v11/*: any*/),
              (v15/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "CollectionType",
            "kind": "LinkedField",
            "name": "collections",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "logo",
                "storageKey": null
              },
              (v15/*: any*/)
            ],
            "storageKey": null
          },
          (v11/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v9/*: any*/),
        "concreteType": "WalletType",
        "kind": "LinkedField",
        "name": "wallet",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v10/*: any*/),
            "concreteType": "WalletFundsType",
            "kind": "LinkedField",
            "name": "fundsOf",
            "plural": false,
            "selections": [
              (v11/*: any*/),
              (v15/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "71f4f70ff9a8027a247881658bb1635e",
    "id": null,
    "metadata": {},
    "name": "TransactionConfirmationModalQuery",
    "operationKind": "query",
    "text": "query TransactionConfirmationModalQuery(\n  $data: String!\n  $to: AddressScalar!\n  $from: AddressScalar!\n  $value: BigIntScalar!\n  $chain: ChainScalar!\n  $nativeCurrencySymbol: String!\n) {\n  transactionMetadata(inputData: $data, toAddress: $to, fromAddress: $from, value: $value, chain: $chain) {\n    type\n    ...TransactionDetails_metadata\n    ...useTransactionNativeCurrencyTotal_metadata\n  }\n  wallet(address: $from) {\n    fundsOf(symbol: $nativeCurrencySymbol, chain: $chain) {\n      quantity\n      id\n    }\n  }\n}\n\nfragment AcceptDealTransactionDetails_metadata on TransactionMetadataType {\n  sentAssetQuantities {\n    ...DealSideItemsDisplay_assetQuantities\n    id\n  }\n  receivedAssetQuantities {\n    ...DealSideItemsDisplay_assetQuantities\n    id\n  }\n}\n\nfragment AcceptOfferTransactionDetails_metadata on TransactionMetadataType {\n  sentAssetQuantities {\n    ...TransactionDetailsItems_assetQuantities\n    id\n  }\n  receivedAssetQuantities {\n    asset {\n      usdSpotPrice\n      symbol\n      decimals\n      id\n    }\n    quantity\n    id\n  }\n}\n\nfragment ApproveCollectionTransactionDetails_metadata on TransactionMetadataType {\n  collections {\n    name\n    ...CollectionMedia_collection\n    id\n  }\n}\n\nfragment ApproveCurrencyTransactionDetails_metadata on TransactionMetadataType {\n  sentAssetQuantities {\n    asset {\n      symbol\n      ...PaymentAssetMedia_asset\n      id\n    }\n    id\n  }\n}\n\nfragment CancelDealTransactionDetails_metadata on TransactionMetadataType {\n  sentAssetQuantities {\n    ...DealSideItemsDisplay_assetQuantities\n    id\n  }\n  receivedAssetQuantities {\n    ...DealSideItemsDisplay_assetQuantities\n    id\n  }\n}\n\nfragment CancelListingTransactionDetails_metadata on TransactionMetadataType {\n  sentAssetQuantities {\n    ...TransactionDetailsItems_assetQuantities\n    id\n  }\n  receivedAssetQuantities {\n    asset {\n      usdSpotPrice\n      symbol\n      decimals\n      id\n    }\n    quantity\n    id\n  }\n}\n\nfragment CancelOfferTransactionDetails_metadata on TransactionMetadataType {\n  receivedAssetQuantities {\n    ...TransactionDetailsItems_assetQuantities\n    id\n  }\n  sentAssetQuantities {\n    asset {\n      usdSpotPrice\n      symbol\n      decimals\n      id\n    }\n    quantity\n    id\n  }\n  collections {\n    name\n    ...CollectionMedia_collection\n    id\n  }\n}\n\nfragment CollectionMedia_collection on CollectionType {\n  logo\n}\n\nfragment ConfigureDropTransactionDetails_metadata on TransactionMetadataType {\n  collections {\n    name\n    ...CollectionMedia_collection\n    id\n  }\n}\n\nfragment DealSideItemsDisplay_assetQuantities on AssetQuantityType {\n  asset {\n    displayName\n    tokenStandard\n    symbol\n    decimals\n    ...StackedAssetMedia_assets\n    id\n  }\n  quantity\n}\n\nfragment MintTransactionDetails_metadata on TransactionMetadataType {\n  quantity\n  sentAssetQuantities {\n    asset {\n      decimals\n      symbol\n      usdSpotPrice\n      id\n    }\n    quantity\n    id\n  }\n  collections {\n    name\n    ...CollectionMedia_collection\n    id\n  }\n}\n\nfragment NftTransferTransactionDetails_metadata on TransactionMetadataType {\n  sentAssetQuantities {\n    ...TransactionDetailsItems_assetQuantities\n    id\n  }\n}\n\nfragment PaymentAssetMedia_asset on AssetType {\n  displayImageUrl\n}\n\nfragment PurchaseTransactionDetails_metadata on TransactionMetadataType {\n  sentAssetQuantities {\n    asset {\n      usdSpotPrice\n      symbol\n      decimals\n      id\n    }\n    quantity\n    id\n  }\n  receivedAssetQuantities {\n    ...TransactionDetailsItems_assetQuantities\n    id\n  }\n}\n\nfragment RedeemTransactionDetails_metadata on TransactionMetadataType {\n  collections {\n    name\n    ...CollectionMedia_collection\n    id\n  }\n}\n\nfragment StackedAssetMedia_assets on AssetType {\n  displayImageUrl\n}\n\nfragment TransactionDetailsItems_assetQuantities on AssetQuantityType {\n  asset {\n    displayName\n    ...StackedAssetMedia_assets\n    id\n  }\n  quantity\n}\n\nfragment TransactionDetails_metadata on TransactionMetadataType {\n  type\n  ...PurchaseTransactionDetails_metadata\n  ...CancelListingTransactionDetails_metadata\n  ...CancelOfferTransactionDetails_metadata\n  ...CancelDealTransactionDetails_metadata\n  ...AcceptOfferTransactionDetails_metadata\n  ...ApproveCollectionTransactionDetails_metadata\n  ...ApproveCurrencyTransactionDetails_metadata\n  ...NftTransferTransactionDetails_metadata\n  ...MintTransactionDetails_metadata\n  ...AcceptDealTransactionDetails_metadata\n  ...WrapTransactionDetails_metadata\n  ...UnwrapTransactionDetails_metadata\n  ...RedeemTransactionDetails_metadata\n  ...ConfigureDropTransactionDetails_metadata\n}\n\nfragment UnwrapTransactionDetails_metadata on TransactionMetadataType {\n  sentAssetQuantities {\n    asset {\n      usdSpotPrice\n      symbol\n      decimals\n      ...PaymentAssetMedia_asset\n      id\n    }\n    quantity\n    id\n  }\n}\n\nfragment WrapTransactionDetails_metadata on TransactionMetadataType {\n  sentAssetQuantities {\n    asset {\n      usdSpotPrice\n      symbol\n      decimals\n      ...PaymentAssetMedia_asset\n      id\n    }\n    quantity\n    id\n  }\n}\n\nfragment useTransactionNativeCurrencyTotal_metadata on TransactionMetadataType {\n  sentAssetQuantities {\n    asset {\n      tokenStandard\n      symbol\n      id\n    }\n    quantity\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "f7e18af5c2e272aa403137862d98f321";

export default node;
